(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/subpage/assets/javascripts/utils/utils.js') >= 0) return;  svs.modules.push('/components/accountservices/subpage/assets/javascripts/utils/utils.js');

'use strict';

svs.accountservices = svs.accountservices || {};
svs.accountservices.subpage = svs.accountservices.subpage || {};
svs.accountservices.subpage.utils = {
  handleHeaderAndNavigation(pageTitle, subPageTitle, hamburgerCallback, url) {
    const isPnp = svs.core.config.data.svsconfig.site === 'momang';
    const menuButton = document.getElementsByClassName('pnp-back-button')[0];
    const searchButtons = document.querySelectorAll('.pnp-header-nav-button-icon');
    if (svs.core.detect.formfactor.mobile() || svs.core.detect.breakpoint.equals('xs')) {
      svs.core.template.updateConfig({
        title: {
          row1: {
            text: subPageTitle ? subPageTitle : pageTitle,
            emblemDisabled: Boolean(subPageTitle)
          }
        }
      });
      if (subPageTitle) {
        if (hamburgerCallback) {
          svs.components.navigation.setHamburgerCallback(() => hamburgerCallback(url));
        }
        svs.components.navigation.setHamburgerIcon('arrow-left');
        if (isPnp) {
          menuButton.classList.add('show');
          menuButton.addEventListener('click', () => hamburgerCallback(url));
          searchButtons.forEach(e => e.classList.add('hidden-xs'));
        }
      } else if (isPnp) {
        menuButton.classList.remove('show');
        searchButtons.forEach(e => e.classList.remove('hidden-xs'));
      } else {
        svs.components.navigation.setHamburgerIcon('menu');
        svs.components.navigation.restoreHamburgerCallback();
      }
    }
  }
};

 })(window);